// Framework-agnostic pub-sub bridging the service-worker registration
// (service-worker.ts, which talks to workbox-window) and the React tree
// (UpdateAvailableToast). Kept separate from service-worker.ts so it can be
// unit-tested without mocking browser/SW globals.
type Listener = (available: boolean) => void;

let applyFn: (() => void) | null = null;
const listeners = new Set<Listener>();

export function subscribeUpdateAvailable(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function setUpdateAvailable(apply: () => void): void {
  applyFn = apply;
  for (const listener of listeners) listener(true);
}

export function clearUpdateAvailable(): void {
  applyFn = null;
  for (const listener of listeners) listener(false);
}

export function applyUpdate(): void {
  applyFn?.();
}
